export default function DelayCommonModal<T extends any[]>(
    func: (...args: T) => void,
    ...args: T
  ): void {
    setTimeout(() => {
      func(...args);
    }, 1000);
  }
